import { default as Api } from './Apis'

export async function getServicesMenu() {
    const response = await Api.get('/services/menu')  // chờ API rồi đổ vô đây
    return response     // Ở đây ko cần ".data" nữa vì đã config chung ở trong interceptor rồi.
}